import { useMutation, useQueryClient } from "@tanstack/react-query";
import { OPERATION_KEYS } from "./keys";
import { operationServices } from "./operation.services";

export const useCreateSupply = () => {
  return useMutation({
    mutationKey: [OPERATION_KEYS.SUPPLY, "create"],
    mutationFn: operationServices.createSupply,
  });
};

export const useUpdateSupply = () => {
  return useMutation({
    mutationKey: [OPERATION_KEYS.SUPPLY, "update"],
    mutationFn: operationServices.updateSupply,
  });
};

export const useDeleteSupply = () => {
  return useMutation({
    mutationKey: [OPERATION_KEYS.SUPPLY, "delete"],
    mutationFn: operationServices.deleteSupply,
  });
};

export const useCreateVessel = () => {
  return useMutation({
    mutationKey: [OPERATION_KEYS.VESSEL, "create"],
    mutationFn: operationServices.createVessel,
  });
};

export const useCreateStaff = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: operationServices.createStaff,
    onSuccess: () => {
      qc.invalidateQueries({
        queryKey: [OPERATION_KEYS.STAFF],
      });
    },
  });
};

export const useUpdateStaff = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: operationServices.updateStaff,
    onSuccess: () => {
      qc.invalidateQueries({
        queryKey: [OPERATION_KEYS.STAFF],
      });
    },
  });
};
